import { useState, useEffect } from "react";
import { FaCheckCircle, FaLightbulb, FaUserShield } from "react-icons/fa";

export default function Seccion3() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [
    "/images/foto.jpeg",
    "/images/foto2.jpeg",
    "/images/foto3.jpeg"
  ];

  // Función para cambiar la imagen automáticamente cada 5 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Cambia cada 5 segundos

    return () => clearInterval(interval); // Limpiar el intervalo cuando el componente se desmonte
  }, []);

  const handleImageChange = (index) => {
    setCurrentIndex(index);
  };

  const handleWhatsAppClick = () => {
    window.open("https://wa.me/+5492612444001", "_blank");
  };

  return (
    <div id="seccion3" className="bg-white py-16 px-6 text-gray-800 relative">
      {/* Fondo con imagen de logo en baja opacidad */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/images/logo.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.05, // Baja opacidad para el fondo
        }}
      ></div>

      <div className="max-w-7xl mx-auto text-center relative z-10">
        {/* Título Principal */}
        <h2 className="text-4xl font-bold mb-8 text-gray-900">Sobre Mí</h2>

        {/* Carrusel de Imágenes */}
        <div className="relative mb-10">
          <div className="w-full h-100 overflow-hidden rounded-lg shadow-md">
            <img
              src={images[currentIndex]}
              alt="Carlos Laspina"
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Controles del Carrusel (Flechas) */}
          <div className="absolute top-1/2 left-0 transform -translate-y-1/2 text-white text-3xl px-4 cursor-pointer" onClick={() => setCurrentIndex((currentIndex - 1 + images.length) % images.length)}>
            &#8592;
          </div>
          <div className="absolute top-1/2 right-0 transform -translate-y-1/2 text-white text-3xl px-4 cursor-pointer" onClick={() => setCurrentIndex((currentIndex + 1) % images.length)}>
            &#8594;
          </div>
        </div>

        {/* Misión y Objetivo */}
        <p className="text-lg max-w-3xl mx-auto mb-10 px-4 text-gray-700">
          Soy Carlos Laspina, especialista en Investigación y Análisis de Incendios. Mi misión es proporcionar soluciones de alta calidad para ayudar a empresas,
          organismos gubernamentales y particulares a comprender, mitigar y prevenir los riesgos asociados con los incendios. Con más de 10 años de experiencia,
          ofrezco pericias detalladas y fundamentadas para la realización de informes técnicos, siempre con un enfoque en la seguridad y prevención.
        </p>

        <p className="text-lg max-w-3xl mx-auto mb-12 px-4 text-gray-700">
          Mi compromiso es ser un referente en el sector en Argentina, asegurando resultados confiables a través de la ética, integridad y profesionalismo.
        </p>

        {/* Valores */}
        <h3 className="text-3xl font-semibold mb-6 text-gray-900">Mis Valores</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
          <div className="text-center">
            <FaCheckCircle className="text-4xl text-green-500 mb-4 mx-auto" />
            <h4 className="text-xl font-semibold mb-2">Compromiso con la calidad</h4>
            <p className="text-lg text-gray-600">Utilizo tecnología avanzada y metodologías de vanguardia para garantizar servicios precisos y eficaces.</p>
          </div>
          <div className="text-center">
            <FaLightbulb className="text-4xl text-yellow-500 mb-4 mx-auto" />
            <h4 className="text-xl font-semibold mb-2">Innovación y mejora continua</h4>
            <p className="text-lg text-gray-600">Me mantengo actualizado con las últimas tecnologías y técnicas para ofrecer soluciones eficientes y efectivas.</p>
          </div>
          <div className="text-center">
            <FaUserShield className="text-4xl text-blue-500 mb-4 mx-auto" />
            <h4 className="text-xl font-semibold mb-2">Integridad y ética</h4>
            <p className="text-lg text-gray-600">Trabajo con total transparencia y confidencialidad en cada proyecto.</p>
          </div>
        </div>

        {/* Ventajas de Trabajar Contigo */}
        <h3 className="text-3xl font-semibold mb-6 text-gray-900 mt-10">Ventajas de Trabajar Conmigo</h3>
        <ul className="list-disc list-inside text-lg max-w-3xl mx-auto text-gray-600 mb-8 px-6">
          <li>Experiencia y Conocimiento: Con más de una década de experiencia, garantizo servicios de alta calidad y precisión.</li>
          <li>Compromiso con la Calidad: Trabajo de cerca con cada cliente para asegurar que sus necesidades sean atendidas con profesionalismo.</li>
          <li>Flexibilidad y Adaptabilidad: Me adapto a los requerimientos específicos de cada cliente y situación.</li>
          <li>Desarrollo de Informes Periciales: Elaboro informes técnicos detallados sobre siniestros, fundamentales para decisiones legales y técnicas.</li>
        </ul>

        {/* Llamada a la Acción */}
        <div className="mt-12">
          <p className="text-lg text-gray-700 mb-6">Si necesitas un especialista en investigación y seguridad contra incendios, ¡contáctame y juntos trabajaremos en la prevención y mitigación de riesgos!</p>
          <button
            onClick={handleWhatsAppClick}
            className="bg-green-500 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-green-600"
          >
            Contactar por WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
}

